// extracted by mini-css-extract-plugin
module.exports = {"yt-video":"Video_yt-video__dc71K"};